<script lang="ts" setup>
import { UiIcon } from '@common/ui-kit'
import IconServiceChecker from "~/components/sx/icons/services/IconServiceChecker.vue";
import IconServiceIpn from "~/components/sx/icons/services/IconServiceIpn.vue";
import {capitalize} from "vue";
import PopupPrices from "~/components/sx/popupContent/PopupPrices.vue";

const { t } = useLocale();
const { locale: localeI18n } = useI18n();

const items = shallowRef({
  // types: {
  //   title: 'Прокси',
  //   content: [
  //     {
  //       icon: 'smartphone',
  //       blank: false,
  //       name: 'Мобильные',
  //       desc: 'Реальные устройства, лучшие операторы связи, неограниченная пропускная способность',
  //       sub: 4.5,
  //       link: 'proxy/mobile',
  //       translate: true,
  //     },
  //     {
  //       icon: 'location',
  //       blank: false,
  //       name: 'Резидентные',
  //       desc: 'IP-адреса из сетей домашнего интернета. Работа через данные прокси максимально приближена к обычным сессиям',
  //       sub: 4.13,
  //       link: 'proxy/resident',
  //       translate: true,
  //     },
  //     {
  //       icon: 'groups',
  //       blank: false,
  //       name: 'Корпоративные',
  //       desc: 'Быстрое масштабирование и интеграция с максимальной производительностью',
  //       sub: 0.7,
  //       link: 'proxy/corporate',
  //       translate: true,
  //     },
  //   ]
  // },
  extra: {
    title: 'Дополнительно',
    content: [
      {
        icon: 'paid',
        blank: false,
        name: 'Цены',
        desc: 'Каждый тип прокси имеет свою цену за гигабайт, и чем больше вы готовы тратить денег на трафик тем дешевле для вас будет гигабайт этих проксей',
        sub: '',
        link: '#prices',
        translate: true,
      },
      {
        icon: 'language',
        blank: false,
        name: 'Geo',
        desc: 'Широкий выбор из 235 стран и более 100 000 городов',
        sub: '',
        link: 'geo',
        translate: false,
      },
      {
        icon: 'handyman',
        blank: false,
        name: 'Разработчикам',
        desc: 'Универсальное решение для разработчиков, ищущих стабильное соединение и широкий функционал API',
        sub: '',
        link: 'developers',
        translate: true,
      },
    ],
  },
  services: {
    title: 'Сервисы',
    content: [
      {
        icon: markRaw(IconServiceChecker),
        blank: true,
        name: 'Proxy Checker',
        desc: 'Проверяйте активность прокси, статус блокировки и соответствие параметрам. Все важное — теперь видно сразу',
        sub: '',
        link: 'https://checker.net',
        translate: false,
      },
      {
        icon: markRaw(IconServiceIpn),
        name: 'IP Info',
        blank: true,
        desc: 'Расскажет все про IP. Понимайте, как вас видит сайт — и избегайте банов до того, как они случатся',
        sub: '',
        link: 'https://i.pn',
        translate: false,
      },
    ],
  }
});
</script>

<template>
  <div class="popup-content-proxy">
    <PopupPrices />
    <div v-for="block in items" class="popup-content-proxy__block">
      <div class="popup-content-proxy__title">
        {{ capitalize(t(block.title)) }}
      </div>
      <div class="popup-content-proxy__content">
        <NuxtLink
          v-for="(item, index) in block.content" :key="index"
          :to="item.blank ? item.link : `/${localeI18n}/${item.link}`"
          :target="item.blank ? '_blank' : '_self'"
          class="popup-content-proxy__link"
        >
           <div class="popup-content-proxy__name">
             <UiIcon v-if="!item.blank" type="filled" :name="item.icon" />
             <Component v-else :is="item.icon" />
             {{ item.translate ? capitalize(t(item.name)) : item.name }}
           </div>
            <div class="popup-content-proxy__desc">
              {{ capitalize(t(item.desc)) }}
            </div>
          <div v-if="item.sub" class="popup-content-proxy__sub">
            {{ t('от') }} ${{ item.sub }}
          </div>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.popup-content-proxy {
  display: flex;
  gap: 32px;
  width: 100%;
  &__block {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 320px;
    width: 100%;
  }
  &__title {
    padding-bottom: 12px;
    border-bottom: var(--border-sx-main);
    font-weight: 500;
    font-size: 22px;
    line-height: 20px;
    letter-spacing: 0;
  }
  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  &__link {
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #000;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: -6px;
      left: -12px;
      right: -12px;
      bottom: -6px;
      border-radius: 16px;
      background: #efefef;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
      z-index: -1;
    }
    &:hover::before {
      opacity: 1;
    }
  }
  &__name {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &__desc {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    color: #666666;
  }
  &__sub {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0;
  }
}
</style>
